import { render } from "./StoreGroupHeader.vue?vue&type=template&id=078599aa"
import script from "./StoreGroupHeader.vue?vue&type=script&lang=js"
export * from "./StoreGroupHeader.vue?vue&type=script&lang=js"

import "./StoreGroupHeader.vue?vue&type=style&index=0&id=078599aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__